/**
 * @generated SignedSource<<51e444d99b00343ece91911204021686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SendInvoiceDialog_invoice$data = {
  readonly id: string;
  readonly sentAt: any | null | undefined;
  readonly " $fragmentType": "SendInvoiceDialog_invoice";
};
export type SendInvoiceDialog_invoice$key = {
  readonly " $data"?: SendInvoiceDialog_invoice$data;
  readonly " $fragmentSpreads": FragmentRefs<"SendInvoiceDialog_invoice">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SendInvoiceDialog_invoice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sentAt",
      "storageKey": null
    }
  ],
  "type": "Invoice",
  "abstractKey": null
};

(node as any).hash = "3e57c6fb117b381ea775be2728b37936";

export default node;
